import React, { useState, useEffect } from 'react';
import { useAuth } from '@trip-planner-monorepo/shared';
import Modal from 'react-modal';
import { FaTimes } from 'react-icons/fa';
import './EditPlaceModal.css';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const EditPlaceModal = ({ isOpen, onClose, onSave, initialPlace }) => {
    const [name, setName] = useState('');
    const [context, setContext] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (initialPlace) {
            setName(initialPlace.name || '');
            setContext(initialPlace.context || '');
        }
    }, [initialPlace]);

    const handleSave = async () => {
        if (!name.trim()) return; // Basic validation

        setSaving(true);
        try {
            await onSave({
                ...initialPlace,
                name,
                context
            });
            // Note: do NOT call onClose() here — the onSave handler in PlaceDetails
            // already calls setIsEditing(false) to close the modal. Calling onClose()
            // (which is handleCancelDetails) after onSave would revert state to the
            // stale pre-save value due to React closure capture.
        } catch (error) {
            console.error("Failed to save place:", error);
            // Ideally handle error display here
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="edit-place-modal"
            overlayClassName="modal-overlay"
            contentLabel="Edit Place Details"
        >
            <div className="modal-header">
                <h2>Edit Place Details</h2>
                <button onClick={onClose} className="close-button" aria-label="Close modal">
                    <FaTimes />
                </button>
            </div>

            <div className="modal-body">
                <div className="form-group">
                    <label htmlFor="place-name">Name</label>
                    <input
                        id="place-name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="form-input"
                        autoFocus
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="place-context">Context</label>
                    <input
                        id="place-context"
                        type="text"
                        value={context}
                        onChange={(e) => setContext(e.target.value)}
                        className="form-input"
                        placeholder="e.g. Paris, France"
                    />
                </div>
            </div>

            <div className="modal-footer">
                <button className="cancel-button" onClick={onClose} disabled={saving}>
                    Cancel
                </button>
                <button className="save-button" onClick={handleSave} disabled={saving || !name.trim()}>
                    {saving ? 'Saving...' : 'Save Changes'}
                </button>
            </div>
        </Modal>
    );
};

export default EditPlaceModal;
